<template>
  <div class="scdy-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small"  @submit.native.prevent>
            <el-form-item style="float: right">
              <el-button type="primary" size="small" @click="editRow(null)" icon="el-icon-plus">添加调研</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="marketResearchData"
              stripe
              style="width: 100%;margin-bottom: 20px"
              @row-click="openDetails">
              <el-table-column
                align="center"
                label="城市"
                width="160"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <div>{{scope.row.province}}/{{scope.row.city}}</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="调研时间"
                width="180"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <div>{{scope.row.startdate}} - {{scope.row.enddate}}</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="time"
                label="提交日期"
                width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="market"
                label="市场情况"
                min-width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="180"
                fixed="right"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" @click.stop="editRow(scope.row)" size="mini">编辑</el-button>
                  <el-button icon="el-icon-delete" @click.stop="delRow(scope.row)" size="mini">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editDialog"
      width="40%"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true">
      <el-form size="small" ref="eForm" :model="eForm" :rules="eRules" label-width="90px" >
        <el-form-item label="城市" prop="city">
          <el-cascader
            style="width:100%"
            v-model="eForm.city"
            :options="cityoptions"
            placeholder="请选择调研城市"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="调研时间" prop="time">
          <el-date-picker
            v-model="eForm.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="市场情况分析" prop="market">
          <el-input type="textarea" v-model="eForm.market" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="入住品牌情况" prop="brand">
          <el-input type="textarea" v-model="eForm.brand" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="eForm.remark" maxlength="400"  show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="招商经理建议" prop="mansug">
          <el-input type="textarea" v-model="eForm.mansug" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="招商总监建议" prop="dirsug">
          <el-input type="textarea" v-model="eForm.dirsug" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="editLoading" type="primary" @click="submitEdit">立即提交</el-button>
          <el-button @click="editDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="40%"
      top="10vh"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="detailLoading">
        <div style="margin-bottom: 5px">调研人：{{detail.name}}</div>
        <div style="margin-bottom: 5px">调研城市：{{detail.province}} - {{detail.city}}</div>
        <div style="margin-bottom: 5px">调研时间：{{detail.startdate}} - {{detail.enddate}}</div>
        <div style="margin-top: 20px;margin-bottom: 10px">市场情况分析</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.market}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">入住品牌情况</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.brand}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">备注</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.remark}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">招商经理建议</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.mansug}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">招商总监建议</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.dirsug}}</div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { delMarketResearch, editMarketResearch, selectMarketResearchList, selectOneByIdMarketResearch } from '@/api/work'
import { getCity } from '@/utils/city'

export default {
  name: 'scdy',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {},
      marketResearchData: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      editTitle: '',
      editDialog: false,
      editLoading: false,
      eForm: {
        mrid: 0,
        userid: null,
        city: [],
        time: [],
        market: '',
        brand: '',
        remark: '',
        mansug: '',
        dirsug: ''
      },
      eRules: {
        city: [{ type: 'array', required: true, message: '请选择城市', trigger: 'blur' }],
        time: [{ required: true, message: '请选择时间', trigger: 'change' }]
      },
      cityoptions: [],
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detail: {
        mrid: null,
        userid: null,
        province: '',
        city: '',
        startdate: '',
        enddate: '',
        market: '',
        brand: '',
        remark: '',
        mansug: '',
        dirsug: '',
        name: ''
      }
    }
  },
  created() {
    this.getData()
    let _cityoptions = getCity()
    for (let a of _cityoptions) {
      for (let b of a.children) {
        b.children = null
      }
    }
    this.cityoptions = _cityoptions
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      selectMarketResearchList(data).then(response => {
        this.loading = false
        this.marketResearchData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    openDetails(row) {
      this.detailVisible = true
      this.detailLoading = true
      selectOneByIdMarketResearch({ userid: this.user.dUserid, mrid: row.mrid }).then(response => {
        this.detail = response.data
        this.detailTitle = response.data.province + '-' + response.data.city + ' 调研详情'
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    delRow(row) {
      this.$confirm('您确定要删除此调研吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        const data = {
          mrid: row.mrid,
          userid: this.user.dUserid
        }
        delMarketResearch(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    editRow(row) {
      if (row !== null) {
        this.editTitle = '编辑调研'
        this.eForm = {
          mrid: row.mrid,
          userid: row.userid,
          city: [row.province, row.city],
          time: [row.startdate, row.enddate],
          market: row.market,
          brand: row.brand,
          remark: row.remark,
          mansug: row.mansug,
          dirsug: row.dirsug
        }
      } else {
        this.editTitle = '添加调研'
        this.eForm = {
          mrid: 0,
          userid: this.user.dUserid,
          city: [],
          time: [],
          market: '',
          brand: '',
          remark: '',
          mansug: '',
          dirsug: ''
        }
      }
      this.editDialog = true
    },
    submitEdit() {
      this.$refs['eForm'].validate((valid) => {
        if (valid) {
          this.$confirm('您确定要提交此调研吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (!this.editloading) {
              this.editloading = true
              const data = {
                mrid: this.eForm.mrid,
                userid: this.eForm.userid,
                groupid: this.user.dGroupid,
                province: this.eForm.city[0],
                city: this.eForm.city[1],
                startdate: this.eForm.time[0],
                enddate: this.eForm.time[1],
                market: this.eForm.market,
                brand: this.eForm.brand,
                remark: this.eForm.remark,
                mansug: this.eForm.mansug,
                dirsug: this.eForm.dirsug
              }
              editMarketResearch(data).then(response => {
                this.$message({
                  type: 'success',
                  message: response.msg
                })
                this.editloading = false
                this.editDialog = false
                this.getData()
              })
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
